// extracted by mini-css-extract-plugin
export default {"logoutActions":"styles_logoutActions__VOqK5","userDetails":"styles_userDetails__WBhhj"};